import React, { useContext } from "react"

// components
import Note from "components/Note/Note"
import { TextInput } from "components-design-system"
import InputWrapper from "../../hoc/InputWrapper/InputWrapper"

const RJTextArea = ({ id, carbonProps, invalid, value, onChange, onFocus, onBlur }) => {
  const variant = invalid ? "error" : undefined

  return (
    <TextInput
      status={variant}
      type="textarea"
      id={`${id}-field`}
      className="rjs-widget"
      style={carbonProps?.styles?.widget}
      disabled={carbonProps?.disabled}
      defaultValue={value}
      onChange={(e) => onChange(e.target.value)}
      onFocus={onFocus}
      onBlur={onBlur}
      autoSize={{ minRows: 3 }}
    />
  )
}

export default InputWrapper(RJTextArea)
